// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"6879ba19","693":"4d44a299","983":"afd12a51"}[chunkId] + ".chunk.js";
};